/** Normalize Meta asset ids for stable equality in select filters. */
export function normalizeMetaAssetId(
  id: string | undefined | null
): string | undefined {
  const trimmed = id?.trim();
  return trimmed ? trimmed : undefined;
}

export function isSameMetaAssetId(
  a: string | undefined | null,
  b: string | undefined | null
): boolean {
  const normalizedA = normalizeMetaAssetId(a);
  const normalizedB = normalizeMetaAssetId(b);
  return Boolean(normalizedA && normalizedB && normalizedA === normalizedB);
}

export function filterSelectOptionsExcludingId<T>(
  options: T[],
  excludedId: string | undefined,
  getOptionId: (option: T) => string | undefined
): T[] {
  const excluded = normalizeMetaAssetId(excludedId);
  if (!excluded) return options;
  return options.filter(
    (option) => normalizeMetaAssetId(getOptionId(option)) !== excluded
  );
}
